import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'redux-actions';
import {
  Button,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Typography,
} from 'antd';
import { formatters } from 'services';
import type { Dayjs } from 'dayjs';
import type { RangePickerProps } from 'antd/lib/date-picker';
import {
  clearYieldsDownload,
  createClientDealingScenario,
  fetchYieldsAdmin,
} from '../../../state/app/client_money/actions';
import { clearBenchmarkPreview, selectors } from 'state';
import {
  downloadYieldsData,
  fetchedYieldsDownload,
} from '../../../state/app/selectors';
import { CSVLink } from 'react-csv';

const { RangePicker } = DatePicker;
const { Paragraph } = Typography;

type Props = {
  visible: boolean;
  hide: () => void;
};
type MyRange = {
  moments: [Dayjs | null, Dayjs | null] | null;
  strings: [string, string];
};

const CreateClientDealingScenarioModal: React.FC<Props> = ({
  visible,
  hide,
}) => {
  const dispatch = useDispatch();
  const [freq, setFreq] = useState<number>(7);
  const [range, setRange] = useState<MyRange>({
    moments: null,
    strings: ['', ''],
  });
  const [players, setPlayers] = useState<number>(5);
  const [aum, setAum] = useState<number>(100_000_000);
  const [startingLoansCurve, setstartingLoansCurve] = useState<number>(1);
  const [startingDeposCurve, setstartingDeposCurve] = useState<number>(0.6);
  const [loansAlpha, setloansAlpha] = useState<number>(0.96);
  const [loansGamma, setloansGamma] = useState<number>(2);
  const [deposAlpha, setdeposAlpha] = useState<number>(0.96);
  const [deposGamma, setdeposGamma] = useState<number>(5);
  const [initialLoansPool, setinitialLoansPool] =
    useState<number>(1_000_000_000);
  const [initialDeposPool, setinitialDeposPool] =
    useState<number>(1_000_000_000);
  const [name, setName] = useState<string>('sample');
  const fetchedYields = useSelector(selectors.fetchedYieldsDownload);
  const waiting = useSelector(selectors.waiting);
  const yields = useSelector(selectors.downloadYieldsData);

  const handleChange: RangePickerProps['onChange'] = (moments, dateStrings) => {
    // moments is [Moment, Moment] or null if cleared
    // dateStrings is ['YYYY-MM-DD', 'YYYY-MM-DD']
    dispatch(clearYieldsDownload({}));
    setRange({
      moments,
      strings: dateStrings as [string, string],
    });
  };

  const csvData = useMemo(() => {
    const titles = ['timestamp', 'yield_10yr', 'yield_13wk'];

    const body = yields.map((row, index) => {
      return titles.map(title => {
        const value = row[title as keyof typeof row];
        return value;
      });
    });
    body.unshift(titles as string[]);
    return body;
  }, [yields]);

  const inputWidth = 150;
  return (
    <Modal
      title="Create a new scenario"
      open={visible}
      onCancel={() => {
        dispatch(clearYieldsDownload({}));
        hide();
      }}
      onOk={() => {
        // dispatch(action);
        dispatch(
          createClientDealingScenario({
            start_date: range.strings[0],
            end_date: range.strings[1],
            freq: freq,
            players: players,
            aum: aum,
            // poolFactor: poolFactor,
            // startingLdr: startingLDR,
            starting_loans_curve: startingLoansCurve,
            starting_depos_curve: startingDeposCurve,
            loans_alpha: loansAlpha,
            loans_gamma: loansGamma,
            depos_alpha: deposAlpha,
            depos_gamma: deposGamma,
            initial_loans_pool: initialLoansPool,
            initial_depos_pool: initialDeposPool,

            name: name,
          })
        );
        dispatch(clearYieldsDownload({}));
        // hide();
      }}
    >
      <span
        style={{
          width: inputWidth,
          textAlign: 'right',
          display: 'inline-block',
          marginRight: 5,
        }}
      >
        Historical Period:
      </span>
      <DatePicker.RangePicker
        format="YYYY-MM-DD"
        style={{ width: 289 }}
        onChange={handleChange}
      />
      <br />
      <span
        style={{
          width: inputWidth,
          textAlign: 'right',
          display: 'inline-block',
          marginRight: 5,
        }}
      >
        Frequency:
      </span>
      <InputNumber
        min={0}
        step={1}
        style={{ width: inputWidth }}
        value={freq}
        onChange={value => {
          if (typeof value === 'number') setFreq(value);
        }}
      />
      {fetchedYields ? (
        // <Button
        //   // disabled={selectedAsset === null}
        //   // loading={fetching}
        //   type="primary"
        //   // style={{ marginBottom: 16, marginLeft: 10 }}
        // >
        <CSVLink
          style={{ marginLeft: 10 }}
          filename={`${range.strings[0]}_${range.strings[1]}_YIELDS`}
          data={csvData}
          // disabled={selectedAsset === null}
          // loading={fetching}
        >
          Download Yields
        </CSVLink>
      ) : (
        // </Button>
        <Button
          type={'link'}
          onClick={() => {
            dispatch(
              fetchYieldsAdmin({
                start_date: range.strings[0],
                end_date: range.strings[1],
                freq: freq,
              })
            );
          }}
          loading={waiting}
          disabled={!range.moments || freq === null}
        >
          Fetch Yields
        </Button>
      )}

      <br />
      <br />

      <span
        style={{
          width: inputWidth,
          textAlign: 'right',
          display: 'inline-block',
          marginRight: 5,
        }}
      >
        No. of players:
      </span>
      <InputNumber
        min={0}
        style={{ width: inputWidth }}
        value={players}
        onChange={value => {
          if (typeof value === 'number') setPlayers(value);
        }}
      />
      <br />
      <span
        style={{
          width: inputWidth,
          textAlign: 'right',
          display: 'inline-block',
          marginRight: 5,
        }}
      >
        AUM:
      </span>
      <InputNumber
        min={0}
        style={{ width: inputWidth }}
        formatter={formatters.commasNoDigits}
        value={aum}
        step={10_000_000}
        onChange={value => {
          if (typeof value === 'number') setAum(value);
        }}
      />
      {/*<br />*/}
      {/*<span*/}
      {/*  style={{*/}
      {/*    width: inputWidth,*/}
      {/*    textAlign: 'right',*/}
      {/*    display: 'inline-block',*/}
      {/*    marginRight: 5,*/}
      {/*  }}*/}
      {/*>*/}
      {/*  Pool factor:*/}
      {/*</span>*/}
      {/*<InputNumber*/}
      {/*  min={0}*/}
      {/*  style={{ width: inputWidth }}*/}
      {/*  formatter={formatters.commasNoDigits}*/}
      {/*  value={poolFactor}*/}
      {/*  step={1}*/}
      {/*  onChange={value => {*/}
      {/*    if (value !== undefined) setPoolFactor(value);*/}
      {/*  }}*/}
      {/*/>*/}

      {/*<br />*/}
      {/*<span*/}
      {/*  style={{*/}
      {/*    width: inputWidth,*/}
      {/*    textAlign: 'right',*/}
      {/*    display: 'inline-block',*/}
      {/*    marginRight: 5,*/}
      {/*  }}*/}
      {/*>*/}
      {/*  Total pool:*/}
      {/*</span>*/}
      {/*<InputNumber*/}
      {/*  min={0}*/}
      {/*  disabled={true}*/}
      {/*  style={{ width: inputWidth }}*/}
      {/*  formatter={formatters.commasNoDigits}*/}
      {/*  value={poolFactor * players * aum}*/}
      {/*  step={1}*/}
      {/*  // onChange={value => {*/}
      {/*  //   if (value !== undefined) setPoolFactor(value);*/}
      {/*  // }}*/}
      {/*/>*/}
      {/*<br />*/}
      {/*<span*/}
      {/*  style={{*/}
      {/*    width: inputWidth,*/}
      {/*    textAlign: 'right',*/}
      {/*    display: 'inline-block',*/}
      {/*    marginRight: 5,*/}
      {/*  }}*/}
      {/*>*/}
      {/*  Starting LDR:*/}
      {/*</span>*/}
      {/*<InputNumber*/}
      {/*  min={0}*/}
      {/*  style={{ width: inputWidth }}*/}
      {/*  formatter={formatters.commas1Digit}*/}
      {/*  value={startingLDR}*/}
      {/*  step={0.1}*/}
      {/*  onChange={value => {*/}
      {/*    if (value !== undefined) setStartingLDR(value);*/}
      {/*  }}*/}
      {/*/>*/}
      <br />
      <span
        style={{
          width: inputWidth,
          textAlign: 'right',
          display: 'inline-block',
          marginRight: 5,
        }}
      >
        Starting Loans curve:
      </span>
      <InputNumber
        min={0}
        style={{ width: inputWidth }}
        formatter={formatters.commas1Digit}
        // value={startingLDR}
        value={startingLoansCurve}
        step={0.1}
        onChange={value => {
          if (typeof value === 'number') setstartingLoansCurve(value);
        }}
      />
      <br />
      <span
        style={{
          width: inputWidth,
          textAlign: 'right',
          display: 'inline-block',
          marginRight: 5,
        }}
      >
        Starting Depos curve:
      </span>
      <InputNumber
        min={0}
        style={{ width: inputWidth }}
        formatter={formatters.commas1Digit}
        // value={startingLDR}
        value={startingDeposCurve}
        step={0.1}
        onChange={value => {
          if (typeof value === 'number') setstartingDeposCurve(value);
        }}
      />
      <br />
      <span
        style={{
          width: inputWidth,
          textAlign: 'right',
          display: 'inline-block',
          marginRight: 5,
        }}
      >
        Loans Alpha:
      </span>
      <InputNumber
        min={0}
        style={{ width: inputWidth }}
        formatter={formatters.commasExact3Digits}
        value={loansAlpha}
        step={0.01}
        onChange={value => {
          if (typeof value === 'number') setloansAlpha(value);
        }}
      />
      <br />
      <span
        style={{
          width: inputWidth,
          textAlign: 'right',
          display: 'inline-block',
          marginRight: 5,
        }}
      >
        Loans Gamma:
      </span>
      <InputNumber
        min={0}
        style={{ width: inputWidth }}
        formatter={formatters.commas1Digit}
        value={loansGamma}
        step={0.1}
        onChange={value => {
          if (typeof value === 'number') setloansGamma(value);
        }}
      />
      <br />
      <span
        style={{
          width: inputWidth,
          textAlign: 'right',
          display: 'inline-block',
          marginRight: 5,
        }}
      >
        Depos Alpha:
      </span>
      <InputNumber
        min={0}
        style={{ width: inputWidth }}
        formatter={formatters.commasExact3Digits}
        value={deposAlpha}
        step={0.01}
        onChange={value => {
          if (typeof value === 'number') setdeposAlpha(value);
        }}
      />
      <br />
      <span
        style={{
          width: inputWidth,
          textAlign: 'right',
          display: 'inline-block',
          marginRight: 5,
        }}
      >
        Depos Gamma:
      </span>
      <InputNumber
        min={0}
        style={{ width: inputWidth }}
        formatter={formatters.commas1Digit}
        value={deposGamma}
        step={0.1}
        onChange={value => {
          if (typeof value === 'number') setdeposGamma(value);
        }}
      />
      <br />
      <span
        style={{
          width: inputWidth,
          textAlign: 'right',
          display: 'inline-block',
          marginRight: 5,
        }}
      >
        Initial Loans Pool:
      </span>
      <InputNumber
        min={0}
        style={{ width: inputWidth }}
        formatter={formatters.commas1Digit}
        value={initialLoansPool}
        step={100_000_000}
        onChange={value => {
          if (typeof value === 'number') setinitialLoansPool(value);
        }}
      />
      <br />
      <span
        style={{
          width: inputWidth,
          textAlign: 'right',
          display: 'inline-block',
          marginRight: 5,
        }}
      >
        Initial Depos Pool:
      </span>
      <InputNumber
        min={0}
        style={{ width: inputWidth }}
        formatter={formatters.commas1Digit}
        value={initialDeposPool}
        step={100_000_000}
        onChange={value => {
          if (typeof value === 'number') setinitialDeposPool(value);
        }}
      />
      <br />
      <br />
      <span
        style={{
          width: inputWidth,
          textAlign: 'right',
          display: 'inline-block',
          marginRight: 5,
        }}
      >
        Name:
      </span>
      <Input
        // min={0}
        style={{ width: inputWidth }}
        // formatter={formatters.commasExact3Digits}
        value={name}
        // step={0.01}
        onChange={value => {
          if (value !== undefined) setName(value.target.value);
        }}
      />
    </Modal>
  );
};

export default CreateClientDealingScenarioModal;
